import {
    ColumnIndex,
    IGridModelView,
    IMeasureBag,
    IMutableGridModel
} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {GUID} from '@mintdata/mint-kit/api/models/GUID';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

export type OnMeasureDone = (measureBag:IMeasureBag) => (void);

export class GridMeasureRequest
{
    public readonly id:GUID = IdUtil.newGUID();

    constructor(public readonly gridModel:IMutableGridModel,
                public readonly viewToMeasure:IGridModelView,
                public readonly numRowsToMeasure:ColumnIndex,
                public readonly numColumnsToMeasure:ColumnIndex,
                public readonly horizontalCellPadding:number,
                public readonly verticalCellPadding:number,
                public onMeasureDone:OnMeasureDone)
    {
    }
}

